import { AxiosInstance, AxiosPromise } from 'axios';
import {
  CaseEndpoint,
  CreateCaseLabelRequest,
  CreateCaseLabelResponse,
  UpdateCaseLabelRequest,
  UpdateCaseLabelResponse,
  DeleteCaseLabelRequest,
  DeleteCaseLabelResponse,
  GetCaseLabelsRequest,
  GetCaseLabelsResponse,
} from './CaseServices.types';

export class CaseSevices implements CaseEndpoint {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  createCaseLabel(request: CreateCaseLabelRequest): AxiosPromise<CreateCaseLabelResponse> {
    return this.instance.post('/case-label', request.body);
  }

  getCaseLabels(request: GetCaseLabelsRequest): AxiosPromise<GetCaseLabelsResponse> {
    return this.instance.get('/case/labels', { params: request.queryParams });
  }

  updateCaseLabel(request: UpdateCaseLabelRequest): AxiosPromise<UpdateCaseLabelResponse> {
    return this.instance.put(`/case-label/${request.routeParams.caseId}`, request.body);
  }

  deleteCaseLabel(request: DeleteCaseLabelRequest): AxiosPromise<DeleteCaseLabelResponse> {
    return this.instance.delete(`/case-label/${request.routeParams.caseId}`);
  }
}
